import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "nfe-shell" }
const _hoisted_2 = { class: "nfe-head" }
const _hoisted_3 = {
  key: 0,
  class: "scan-section"
}
const _hoisted_4 = { class: "scan-row" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "error-text"
}
const _hoisted_7 = {
  key: 1,
  class: "nf-review"
}
const _hoisted_8 = { class: "nf-summary" }
const _hoisted_9 = { class: "summary-row" }
const _hoisted_10 = { class: "summary-val" }
const _hoisted_11 = { class: "summary-row" }
const _hoisted_12 = { class: "summary-val summary-val--small" }
const _hoisted_13 = { class: "summary-row" }
const _hoisted_14 = { class: "summary-val" }
const _hoisted_15 = { class: "items-list" }
const _hoisted_16 = { class: "item-desc" }
const _hoisted_17 = { class: "item-fields" }
const _hoisted_18 = { class: "item-field" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "item-field" }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = { class: "item-field item-field--full" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "item-field item-field--checkbox"
}
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = {
  key: 0,
  class: "error-text"
}
const _hoisted_28 = { class: "import-actions" }
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "nfe-title" }, "Importar Nota Fiscal", -1)),
      _createElementVNode("button", {
        class: "btn-back",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("svg", {
          width: "13",
          height: "13",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [
          _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
        ], -1),
        _createTextVNode(" Voltar ", -1)
      ]))])
    ]),
    (!_ctx.nfData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"scan-hint\" data-v-351674df><svg width=\"32\" height=\"32\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.4\" data-v-351674df><path d=\"M3 9V5a2 2 0 0 1 2-2h4\" data-v-351674df></path><path d=\"M21 9V5a2 2 0 0 0-2-2h-4\" data-v-351674df></path><path d=\"M3 15v4a2 2 0 0 0 2 2h4\" data-v-351674df></path><path d=\"M21 15v4a2 2 0 0 0-2 2h-4\" data-v-351674df></path><line x1=\"7\" y1=\"12\" x2=\"7\" y2=\"12\" data-v-351674df></line><line x1=\"12\" y1=\"12\" x2=\"12\" y2=\"12\" data-v-351674df></line><line x1=\"17\" y1=\"12\" x2=\"17\" y2=\"12\" data-v-351674df></line></svg><span data-v-351674df>Escaneie o código de barras do DANFE ou digite a chave de acesso (44 dígitos)</span></div>", 1)),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              ref: "barcodeInput",
              class: "scan-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.barcode) = $event)),
              placeholder: "Chave de acesso NFe (44 dígitos)",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.lookup && _ctx.lookup(...args)), ["enter"])),
              maxlength: "50"
            }, null, 544), [
              [_vModelText, _ctx.barcode]
            ]),
            _createElementVNode("button", {
              class: "btn-scan",
              type: "button",
              disabled: _ctx.looking,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.lookup && _ctx.lookup(...args)))
            }, _toDisplayString(_ctx.looking ? 'Consultando...' : 'Consultar'), 9, _hoisted_5)
          ]),
          (_ctx.lookupError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.lookupError), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.nfData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "summary-label" }, "Emitente:", -1)),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.nfData.emitenteNome || _ctx.nfData.emitenteCNPJ || '—'), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "summary-label" }, "Chave:", -1)),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.nfData.chave), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "summary-label" }, "Itens encontrados:", -1)),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.nfData.items.length), 1)
            ]),
            _createElementVNode("button", {
              class: "btn-rescan",
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            }, "Escanear outra NF")
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewItems, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "nf-item-card"
              }, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(item.description), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "item-field-label" }, "Quantidade", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "item-input",
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((item.quantidade) = $event),
                      min: "0",
                      step: "0.01"
                    }, null, 8, _hoisted_19), [
                      [
                        _vModelText,
                        item.quantidade,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_20, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "item-field-label" }, "Valor unitário (R$)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "item-input",
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((item.valorUnitario) = $event),
                      min: "0",
                      step: "0.01"
                    }, null, 8, _hoisted_21), [
                      [
                        _vModelText,
                        item.valorUnitario,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "item-field-label" }, "Vincular ao estoque", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "item-select",
                      "onUpdate:modelValue": ($event: any) => ((item.warehouseItemId) = $event)
                    }, [
                      _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "— Criar novo item —", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouseItems, (wi) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: wi.id,
                          value: wi.id
                        }, _toDisplayString(wi.name), 9, _hoisted_24))
                      }), 128))
                    ], 8, _hoisted_23), [
                      [_vModelSelect, item.warehouseItemId]
                    ])
                  ]),
                  (!item.warehouseItemId)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((item.criarNovoItem) = $event)
                        }, null, 8, _hoisted_26), [
                          [_vModelCheckbox, item.criarNovoItem]
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("span", null, "Criar novo item no estoque com esta descrição", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          (_ctx.importError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.importError), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "btn-confirm",
              type: "button",
              disabled: _ctx.importing,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirmImport && _ctx.confirmImport(...args)))
            }, _toDisplayString(_ctx.importing ? 'Importando...' : 'Confirmar Importação'), 9, _hoisted_29),
            _createElementVNode("button", {
              class: "btn-cancel",
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('cancel')))
            }, "Cancelar")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}